"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var constant_1 = require("../../constant");
var style_1 = require("../../style");
var CardDivider = function (props) {
    var theme = react_1.useTheme();
    return (react_1.jsx("div", __assign({}, props, { css: {
            height: '1px',
            backgroundColor: theme.name === constant_1.DESIGN_SYSTEM ? style_1.DesignSystemThemeColor.Gray.LIGHT_4 : '#c6cace',
        } })));
};
exports.default = CardDivider;
